import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PropTypes from "prop-types";
import React, { Component } from "react";
import MailOutline from "@material-ui/icons/MailOutline";
import withStyles from "@material-ui/core/styles/withStyles";

import BouncingLoader from "components/EnergyCompany/BouncingLoader/BouncingLoader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

class Assinatura extends Component {
  state = {
    admin: false,
    email: '',
    loading: false,
    nome: '',
    sobrenome: '',
  };

  handleClick = () => {
    const { admin, email, nome, sobrenome } = this.state;

    this.setState({ loading: true });

    this.props.handleClick({ admin, email, nome, sobrenome })
      .then(() => {
        this.setState({
          admin: false,
          email: '',
          loading: false,
          nome: '',
          sobrenome: '',
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const { email, loading, nome, sobrenome } = this.state;
    const { assinatura, classes } = this.props;

    return (
      <GridContainer>
        <GridItem md={12} sm={12} xs={12}>
          <ECCard
            content={
              assinatura.usuarios.length === assinatura.numeroMaximoUsuarios ? (
                <div>
                  <div>Assinatura já atingiu o limite máximo de {assinatura.numeroMaximoUsuarios} usuário(s).</div>
                  <div><strong>Deseja aumentar a capacidade do seu plano?</strong> Visite nossa página de <a href="/planos">planos</a> ou entre em contato por email <a href="mailto:contato@energycompany.com.br?subject=Olá,%20desejo%20contratar%20um%20plano%20maior">contato@energycompany.com.br</a></div>
                </div>
              ) : (
                <form>
                  <CustomInput
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      onChange: evt => this.setState({ email: evt.target.value }),
                      type: "email",
                      value: email,
                    }}
                    labelText="Email*"
                  />
                  <CustomInput
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      onChange: evt => this.setState({ nome: evt.target.value }),
                      type: "text",
                      value: nome,
                    }}
                    labelText="Nome*"
                  />
                  <CustomInput
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      onChange: evt => this.setState({ sobrenome: evt.target.value }),
                      type: "text",
                      value: sobrenome,
                    }}
                    labelText="Sobrenome"
                  />
                  <div className={classes.checkboxAndRadio}>
                    <FormControlLabel
                      classes={{ label: classes.label }}
                      control={
                        <Checkbox
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          classes={{ checked: classes.checked }}
                          icon={<Check className={classes.uncheckedIcon} />}
                          onClick={evt => this.setState({ admin: evt.target.checked })}
                        />
                      }
                      label="Admin"
                    />
                  </div>
                  {loading ? (
                    <BouncingLoader />
                  ) : (
                    <Button
                      color="rose"
                      disabled={!email || !nome}
                      onClick={this.handleClick}
                    >
                      Convidar
                    </Button>
                  )}
                </form>
              )
            }
            icon={<MailOutline />}
            iconColor="info"
            title="Convidar usuário"
          />
        </GridItem>
      </GridContainer>
    );
  }
}

Assinatura.propTypes = {
  assinatura: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default withStyles(regularFormsStyle)(Assinatura);



// WEBPACK FOOTER //
// ./src/views/Assinatura/partials/ConvidarUsuario.jsx